export abstract class AbstractPaginator {
  public page = 0;
  public size = 20;

  public abstract get pages(): number;
  public abstract get numberElements(): number;

  public get hasNext(): boolean {
    return this.page !== (this.pages - 1);
  }

  public next(): void {
    this.page = Math.min(this.pages - 1, this.page + 1);
  }

  public get hasPrevious(): boolean {
    return this.page !== 0;
  }

  public previous(): void {
    this.page = Math.max(0, this.page - 1);
  }
}
